import { lazy } from 'react';

const Header = lazy(() => import('./Header'));

export { Header };
